import './status-badge.scss';

export type MappingStatus = 'mapped' | 'brand_not_found' | 'unmapped';

export const STATUS_LABEL: Record<MappingStatus, string> = {
  mapped: 'Mapped',
  brand_not_found: 'Brand Not Found',
  unmapped: 'Unmapped',
};

export const StatusBadge: React.FC<{ status: MappingStatus }> = ({
  status,
}) => (
  <span
    className={`tiit-status-badge tiit-status-badge--${status} font-semibold`}
  >
    {STATUS_LABEL[status]}
  </span>
);
